import axiosInstance from "../../../config/axios";
import { store } from "../../store";

export const getOrderHistoryByOrderNumber = async (orderNumber: string, page: number, pageSize: number, customerId: string) => {
    const response = await axiosInstance.get(`/sales/orderHistoryByOrderNumber/${orderNumber}?page=${page}&limit=${pageSize}`,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}
export const getOrderHistory = async (customerId: string, page?: number, limit?: number, startDate?: string, endDate?: string, search?: string) => {
    const queryParams = new URLSearchParams();
    
    if (page !== undefined) queryParams.append('page', page.toString());
    if (limit !== undefined) queryParams.append('limit', limit.toString());
    if (startDate) queryParams.append('startDate', startDate);
    if (endDate) queryParams.append('endDate', endDate);
    if (search) queryParams.append('search', search);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/sales/orderHistory/${customerId}?${queryString}` : `/sales/orderHistory/${customerId}`;
    const response = await axiosInstance.get(url,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}
export const placeOrder = async (customerId: string, params: any) => {
    const response = await axiosInstance.post(`/sales/placeOrder/${customerId}`, params, {
        headers: {
            'customer': customerId,
            'is-web-order': 'true'
        }
    });
    return response.data;
}
export const getInventoryItems = async (customerId: string, params?: any, signal?: AbortSignal) => {
    const storeDetail = store.getState().auth.storeDetail;
    const payload = {
        ...(params || {}),
        state: storeDetail?.C_State,
        zip: storeDetail?.C_Zip,
        jurisdiction: storeDetail?.Jurisdiction_State
    };
    
    const response = await axiosInstance.post(`/sales/getInventoryItems/${customerId}`, payload, {
        headers: {
            'customer': customerId
        },
        ...(signal !== undefined && { signal })
    } as any);
    return response.data;
}
export const getPriceBookInventoryItems = async (customerId: string, params?: any, signal?: AbortSignal) => {
    const storeDetail = store.getState().auth.storeDetail;
    const payload = {
        ...(params || {}),
        state: storeDetail?.C_State,
        zip: storeDetail?.C_Zip,
        jurisdiction: storeDetail?.Jurisdiction_State
    };

    const response = await axiosInstance.post(`/sales/getPriceBookInventoryItems/${customerId}`, payload, {
        headers: {
            'customer': customerId
        },
        ...(signal !== undefined && { signal })
    } as any);
    return response.data;
}
export const getInventoryItemsBySalesRep = async (customerId: string, params?: any, signal?: AbortSignal) => {
    const storeDetail = store.getState().auth.storeDetail;
    const payload = {
        ...(params || {}),
        state: storeDetail?.C_State,
        zip: storeDetail?.C_Zip,
        jurisdiction: storeDetail?.Jurisdiction_State
    };
    
    const response = await axiosInstance.post(`/sales/getInventoryItemsBySalesMan/${customerId}`, payload, {
        headers: {
            'customer': customerId
        },
        ...(signal !== undefined && { signal })
    } as any);
    return response.data;
}
export const getCartItem = async (customerId: string) => {
    const response = await axiosInstance.get(`/sales/cartItem/${customerId}`,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}

export const getSalesWarehouseProfile = async () => {
    const response = await axiosInstance.get('/sales/warehouseProfile');
    return response.data;
}
export const removeFromCart = async (cartItemId: string, customerId: string) => {
    const response = await axiosInstance.delete(`/sales/cartItem/${cartItemId}`,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}
export const clearCart = async (customerId: string, type?: string) => {
    const response = await axiosInstance.delete(`/sales/clearCart/${customerId}`,{
        headers: {
            'customer': customerId
        },
        ...(type ? { params: { type } } : {})
    });
    return response.data;
}
export const updateCartItem = async (cartItemId: string, params: any, customerId: string) => {
    const response = await axiosInstance.put(`/sales/cartItem/${cartItemId}`, params,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}
export const addToCart = async (customerId: string, params: any) => {
    const response = await axiosInstance.post(`/sales/addToCart/${customerId}`, params,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}       

export const getSalesOrderHistoryByProductNumber = async (productNumber: string, customerId: string) => {
    const response = await axiosInstance.get(`/sales/orderHistoryByProductNumber?productNumber=${productNumber}&customerId=${customerId}`,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}
export const getOrderDeliveryStatus = async (id: any, customerId: any) => {
    const response = await axiosInstance.get(`/sales/orderDeliveryStatus/${id}`,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}           

export const getOrderPdf = async (customerId: string, orderId: string, hasPrice: boolean = true, invoiceGenerated: boolean = false) => {
    const params = new URLSearchParams();
    params.append('orderNumber', orderId);
    params.append('hasPrice', hasPrice.toString());
    if (invoiceGenerated) {
        params.append('invoiceGenerated', 'true');
    }
    const response = await axiosInstance.get(`/sales/orderPdf/${customerId}?${params.toString()}`,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}

export const getInvoiceDownloadLink = async (orderNumber: any, customerId?: any) => {
    const response = await axiosInstance.get(`/sales/invoice/${orderNumber}/download-link`, {
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}

export const getDeliveryCharge = async (customerId: string) => {
    const response = await axiosInstance.get(`/sales/deliveryCharge/${customerId}`,{
        headers: {
            'customer': customerId
        }
    });
    return response.data;
}

// Recommendation API
const RECOMMENDER_API_BASE_URL = process.env.REACT_APP_RECOMMENDER_API_URL || 'https://apibytogether.woopsa.app';
const RECOMMENDER_API_KEY = process.env.REACT_APP_RECOMMENDER_API_KEY || 'secret-api-key';

export const getRecommendations = async (userId: string | null, cartItemNumbers: string[]) => {
    try {
        const response = await fetch(`${RECOMMENDER_API_BASE_URL}/recommend`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': RECOMMENDER_API_KEY
            },
            body: JSON.stringify({
                user_id: userId || null,
                cart: cartItemNumbers
            })
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return data; // Array of item numbers
    } catch (error) {
        console.error('Error fetching recommendations:', error);
        return [];
    }
}
export const getInventoryShowPrepaidTax = async () => {
    const response = await axiosInstance.get('/sales/getInventoryShowPrepaidTax');
    return response.data;
}

// headerCustomerId (optional): value sent in the `customer` header for the backend's
// active-session guard. Defaults to customerId. Pass the active session customer when
// requesting data for a different customer (e.g. copy order) to avoid a 409.
export const getSalesCategoryPriceClassByCustomer = async (customerId: string | number, headerCustomerId?: string | number) => {
    const response = await axiosInstance.get(`/sales/getSalesCategoryPriceClassByCustomer/${customerId}`, {
        headers: {
            'customer': (headerCustomerId ?? customerId).toString()
        }
    });
    return response.data;
}

export const getSalesCategoryByCustomer = async (customerId: string | number) => {
    const response = await axiosInstance.get(`/sales/getSalesCategoryByCustomer/${customerId}`, {
        headers: {
            'customer': customerId.toString()
        }
    });
    return response.data;
}

// Validate the given inventory items (item number + qty) against a customer.
// Returns finalProductList with fresh pricing/tax/discount data for that customer.
// Caller builds the full payload (items, salesCategory, state, zip, jurisdiction).
// headerCustomerId (optional): see note on getSalesCategoryPriceClassByCustomer.
export const validateInventoryItems = async (customerId: string | number, params: any, headerCustomerId?: string | number) => {
    const response = await axiosInstance.post(`/sales/validateInventoryItems/${customerId}`, params, {
        headers: {
            'customer': (headerCustomerId ?? customerId).toString()
        }
    });
    return response.data;
}

// Add multiple items to a customer's cart in a single call.
// params: { items: [{ Item_Number, ...cartItemPayload }] }
// headerCustomerId (optional): see note on getSalesCategoryPriceClassByCustomer.
export const bulkAddToCart = async (customerId: string | number, params: any, headerCustomerId?: string | number) => {
    const response = await axiosInstance.post(`/sales/bulkAddToCart/${customerId}`, params, {
        headers: {
            'customer': (headerCustomerId ?? customerId).toString()
        }
    });
    return response.data;
}

// ---- ERP Order Entry > Tools > Merge Order(s) ----
// Pulls other open orders of the same customer into the order being viewed.
// The backend applies the ERP ORDER_ADDON_* option filters (delivery-date window,
// prebook-only, non-invoiced / non-picklisted), so the list can legitimately come
// back empty even when the customer has other orders.

// The customer's other orders that can still be merged into `targetOrderNumber`.
export const getMergeCandidates = async (customerNumber: string | number, targetOrderNumber: string | number) => {
    const response = await axiosInstance.get(
        `/sales/orders/merge/candidates?customerNumber=${customerNumber}&targetOrderNumber=${targetOrderNumber}`,
        {
            headers: {
                'customer': customerNumber.toString()
            }
        }
    );
    return response.data;
}

// How an item the target order already carries should land:
//  'sameLine' (default) — fold into the existing line, adding the quantities
//  'newLine'            — always append a fresh line (this is what the ERP itself does)
export type MergeLineMode = 'sameLine' | 'newLine';

// When the same item sits on both orders at different prices, the user picks which price
// the surviving line keeps. One entry per conflict reported by previewMergeOrders.
export interface MergePriceChoice {
    itemNumber: number;
    // The row whose pricing wins, named by where it lives — not the price value, since two
    // rows can share a Price and still differ in tax.
    orderNumber: number;
    lineNumber: number;
}

// Newer backend shape: the chosen pricing row is named by the order + line it comes from, since
// two rows can share a Price and still differ in tax. Used by Order Entry's merge dialog.
export interface MergePriceRowChoice {
    itemNumber: number;
    orderNumber: number;
    lineNumber: number;
}

// Read-only dry run: which lines move or combine, the Line_Number each lands on, the price
// conflicts needing a decision, totals and warnings.
export const previewMergeOrders = async (
    customerNumber: string | number,
    params: { targetOrderNumber: number; sourceOrderNumbers: number[]; lineMode?: MergeLineMode }
) => {
    const response = await axiosInstance.post(`/sales/orders/merge/preview`, params, {
        headers: {
            'customer': customerNumber.toString()
        }
    });
    return response.data;
}

// Performs the merge. All source orders move inside a single transaction; locked
// orders are reported back in `skipped` instead of failing the whole call.
export const mergeOrders = async (
    customerNumber: string | number,
    params: { targetOrderNumber: number; sourceOrderNumbers: number[]; lineMode?: MergeLineMode; priceChoices?: Array<MergePriceChoice | MergePriceRowChoice> }
) => {
    const response = await axiosInstance.post(`/sales/orders/merge`, params, {
        headers: {
            'customer': customerNumber.toString()
        }
    });
    return response.data;
}